import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class WalletService {

  endpoint = {
    "verify": "/verifyPayment",
    "walletBalance": "/userWallet",
    "transfer": "/fundTransfer"
  }
  private BASE_URL = environment.baseUrl;

  constructor(private walletService: HttpClient) { }

  confirmPayment(data: any){
    let msg = this.walletService.post(this.BASE_URL+this.endpoint.verify, data)
    return msg;
  }

  transferInternal(data:any){
    let msg = this.walletService.post(this.BASE_URL+this.endpoint.transfer, data)
    return msg;
  }

  accountBalance(id: any){
    let balanceReturned = this.walletService.get(`${this.BASE_URL}/${this.endpoint.walletBalance}/${id}`);
    return balanceReturned;
  }




}
